export const cookies = {
  it: {
    title: "Politica dei Cookie",
    intro: {
      title: "Introduzione",
      content: "Le applicazioni software utilizzate su questo sito possono contenere tecnologia \"cookie\". I cookie facilitano principalmente la navigazione dell'utente. Possono fornire informazioni sulla navigazione all'interno del sito e consentire il funzionamento di servizi che richiedono l'identificazione del percorso dell'utente attraverso varie pagine del sito."
    },
    cookieConsent: {
      title: "Usiamo i cookie 🍪",
      description: "Utilizziamo i cookie per personalizzare i contenuti e analizzare il nostro traffico. Puoi accettare o rifiutare i cookie non essenziali.",
      buttons: {
        acceptAll: "Accetta Tutti",
        rejectAll: "Rifiuta Non Essenziali",
        customize: "Personalizza"
      },
      categories: {
        necessary: {
          title: "Cookie Necessari",
          description: "Cookie essenziali per il funzionamento del sito. Non possono essere disattivati."
        },
        analytics: {
          title: "Cookie Analitici",
          description: "Ci aiutano a capire come utilizzi il sito per migliorare l'esperienza utente."
        },
        marketing: {
          title: "Cookie Marketing",
          description: "Vengono utilizzati per fornirti contenuti pertinenti e pubblicità mirate."
        }
      },
      save: "Salva preferenze",
      close: "Chiudi",
      dataProcessing: {
        title: "Nota sul trattamento dei dati:",
        content: "Anche se non utilizzi direttamente i nostri servizi CRM, l'interazione con i nostri agenti AI o i moduli di contatto può comportare l'archiviazione sicura dei tuoi dati (email, cronologia chat) nei nostri sistemi per scopi operativi (Legittimo Interesse)."
      }
    },
    whatAreCookies: {
      title: "Cosa Sono i Cookie?",
      content: "I cookie sono piccole stringhe di testo memorizzate sul computer dell'utente quando si visitano determinate pagine su internet. La maggior parte dei browser è impostata per accettare i cookie. Di seguito sono riportate le informazioni necessarie per modificare le impostazioni dei cookie sul browser. I cookie non sono dannosi per il dispositivo. Nei cookie che generiamo, non memorizziamo informazioni personalmente identificabili ma utilizziamo le informazioni per migliorare la permanenza sul sito."
    },
    types: {
      title: "Tipi di Cookie",
      content: "I cookie si distinguono in cookie \"di sessione\" e \"persistenti\". I primi vengono scaricati e poi eliminati alla chiusura del browser, mentre i secondi vengono memorizzati fino alla loro scadenza o cancellazione.",
      session: {
        title: "Cookie di Sessione",
        content: "I cookie di sessione vengono utilizzati per velocizzare l'analisi del traffico internet e facilitare l'accesso degli utenti ai servizi offerti dal sito."
      },
      firstParty: {
        title: "Cookie di Prima Parte",
        content: "Questi sono cookie che vengono memorizzati direttamente nel tuo computer e non sono controllati da terze parti. Questi cookie consentono ai siti web di richiamare le tue scelte (come il tuo nome utente, la lingua o la regione in cui ti trovi) e offrire funzionalità avanzate personalizzate."
      }
    },
    cookiesWeUse: {
      title: "Quali Cookie Utilizziamo",
      necessary: {
        title: "Cookie Strettamente Necessari",
        content: "Questi sono cookie essenziali per la navigazione del sito (ad esempio, identificatori di sessione) che consentono di utilizzare le funzionalità principali del sito e proteggere la connessione. Senza questi cookie, non sarà possibile utilizzare normalmente il sito."
      },
      navigation: {
        title: "Cookie di Assistenza alla Navigazione",
        content: "Questi cookie aiutano con la navigazione. Ad esempio, memorizzano informazioni sulla lingua preferita."
      },
      thirdParty: {
        title: "Cookie di Terze Parti",
        content: "Questo sito utilizza i seguenti cookie di terze parti. Per il funzionamento dei cookie in Google Analytics, è possibile consultare la documentazione ufficiale fornita da Google."
      }
    },
    consent: {
      title: "Il tuo consenso",
      content: "Il tuo consenso si applica ai seguenti siti web: victorlazari.com",
      status: "Il tuo stato attuale: Accetta tutto."
    },
    howToDisable: {
      title: "Come Posso Disabilitare i Cookie?",
      content: "La maggior parte dei browser accetta automaticamente i cookie, ma puoi scegliere di non accettarli. Se non vuoi che il tuo computer riceva e memorizzi cookie, puoi modificare le impostazioni di sicurezza del tuo browser.",
      browsers: {
        title: "Gestione dei Cookie nei Browser",
        items: [
          "Microsoft Edge",
          "Google Chrome",
          "Mozilla Firefox",
          "Apple Safari"
        ]
      },
      analytics: {
        title: "Disabilitazione di Google Analytics",
        content: "Per disabilitare i cookie analitici e impedire a Google Analytics di raccogliere dati sulla tua navigazione, puoi scaricare il componente aggiuntivo del browser per la disattivazione di Google Analytics."
      }
    },
    lastUpdated: "Ultimo aggiornamento: Settembre 2025 // GDPR_COMPLIANCE_V2"
  },
  en: {
    title: "Cookie Policy",
    intro: {
      title: "Introduction",
      content: "The software applications used on this website may contain \"cookie\" technology. Cookies primarily facilitate user navigation. They can provide information about browsing within the site and allow the functioning of services that require identification of the user's path through various pages of the site."
    },
    cookieConsent: {
      title: "We use cookies 🍪",
      description: "We use cookies to personalize content and analyze our traffic. You can accept or decline non-essential cookies.",
      buttons: {
        acceptAll: "Accept All",
        rejectAll: "Reject Non-Essential",
        customize: "Customize"
      },
      categories: {
        necessary: {
          title: "Necessary Cookies",
          description: "Essential cookies for the site to function. These cannot be disabled."
        },
        analytics: {
          title: "Analytics Cookies",
          description: "Help us understand how you use the site to improve user experience."
        },
        marketing: {
          title: "Marketing Cookies",
          description: "Used to provide you with relevant content and targeted advertising."
        }
      },
      save: "Save preferences",
      close: "Close",
      dataProcessing: {
        title: "Note on Data Processing:",
        content: "Even if you do not use our CRM services directly, interaction with our AI agents or contact forms may result in your data (email, chat history) being securely stored in our systems for operational purposes (Legitimate Interest)."
      }
    },
    whatAreCookies: {
      title: "What Are Cookies?",
      content: "Cookies are small text strings stored on the user's computer when visiting certain pages on the internet. Most browsers are set to accept cookies. Below is the information needed to change cookie settings on your browser. Cookies are not harmful to your device. In the cookies we generate, we do not store personally identifiable information but use the information to improve your stay on the site."
    },
    types: {
      title: "Types of Cookies",
      content: "Cookies are divided into \"session\" cookies and \"persistent\" cookies. The former are downloaded and then deleted when the browser is closed, while the latter are stored until they expire or are deleted.",
      session: {
        title: "Session Cookies",
        content: "Session cookies are used to speed up internet traffic analysis and facilitate user access to services offered by the site."
      },
      firstParty: {
        title: "First-Party Cookies",
        content: "These are cookies that are stored directly on your computer and are not controlled by third parties. These cookies allow websites to recall your choices (such as your username, language, or region) and offer advanced personalized features."
      }
    },
    cookiesWeUse: {
      title: "Which Cookies We Use",
      necessary: {
        title: "Strictly Necessary Cookies",
        content: "These are essential cookies for site navigation (for example, session identifiers) that allow you to use the main features of the site and protect the connection. Without these cookies, it will not be possible to use the site normally."
      },
      navigation: {
        title: "Navigation Assistance Cookies",
        content: "These cookies help with navigation. For example, they store information about preferred language."
      },
      thirdParty: {
        title: "Third-Party Cookies",
        content: "This site uses the following third-party cookies. For information about how Google Analytics cookies work, you can consult the official documentation provided by Google."
      }
    },
    consent: {
      title: "Your Consent",
      content: "Your consent applies to the following websites: victorlazari.com",
      status: "Your current status: Accept all."
    },
    howToDisable: {
      title: "How Can I Disable Cookies?",
      content: "Most browsers automatically accept cookies, but you can choose not to accept them. If you don't want your computer to receive and store cookies, you can modify your browser's security settings.",
      browsers: {
        title: "Cookie Management in Browsers",
        items: [
          "Microsoft Edge",
          "Google Chrome",
          "Mozilla Firefox",
          "Apple Safari"
        ]
      },
      analytics: {
        title: "Disabling Google Analytics",
        content: "To disable analytical cookies and prevent Google Analytics from collecting data about your browsing, you can download the browser add-on for deactivating Google Analytics."
      }
    },
    lastUpdated: "Last updated: September 2025 // GDPR_COMPLIANCE_V2"
  }
};